const getCustomersListUrl = '/crm/customers/';

export default getCustomersListUrl;
